// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-choice[data-v-3875a59e]{flex:0 0 160px;max-width:160px;border:2px solid var(--primary);font-size:var(--button-font-size);font-weight:var(--button-font-weight);text-align:center;padding:var(--spacing-1);cursor:pointer}.radio-left[data-v-3875a59e]{border-right:0}.radio-left[data-v-3875a59e],.radio-right[data-v-3875a59e]{border-radius:0}.radio-active[data-v-3875a59e]{background-color:var(--primary);color:var(--primary-text)}", ""]);
// Exports
module.exports = exports;
